import { render } from "./ExperienceBlock.vue?vue&type=template&id=68986c37&scoped=true"
import script from "./ExperienceBlock.vue?vue&type=script&lang=js"
export * from "./ExperienceBlock.vue?vue&type=script&lang=js"

import "./ExperienceBlock.vue?vue&type=style&index=0&id=68986c37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68986c37"]])

export default __exports__